import { Theme } from '@lib/theming/Theme'
import { Box, Paper, useMediaQuery } from '@material-ui/core'
import { useTheme } from '@material-ui/styles'
import React, { ReactElement } from 'react'

const Panel = ({ children }: { children: ReactElement }) => {
  const { breakpoints } = useTheme<Theme>()
  const mdUp = useMediaQuery(breakpoints.up('md'))
  return (
    <Paper elevation={0}>
      <Box p={mdUp ? 4 : 2}>{children}</Box>
    </Paper>
  )
}

export default Panel
